import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import OrderAddress from "../../entity/emergency/OrderAddress";
import useEmergencyInterventionDemo
    from "../../component/private/intervention/emergency/demo/useEmergencyInterventionDemoServer";

const SERVICE = "service-emergency";
const ENTITY = "order_addresses";

/**
 * @rule-checker exclude
 * @returns {*|void|boolean|{findOneByOrderId(*): {select(): (null|*), exec(boolean=): (undefined|*|void|null|boolean|undefined)}}|null|{select(): (null|*), exec(boolean=): (undefined|*|void|null|boolean|undefined)}}
 */
export default function () {
    const {findOneBy} = useApi();
    const state = useSelector;
    const newInstance = data => new OrderAddress(data);
    const demo = useEmergencyInterventionDemo();

    return {
        findOneByOrderId(id) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.find(c => c?.getOrderId() == id));

                    if (isNull(result)) return null;

                    return result;
                },
                exec(useCache = true) {
                    if (demo.isLockRequest()) {
                        return demo.handleRequest("GET", SERVICE, ENTITY, "order_id", id);
                    }

                    findOneBy(SERVICE, ENTITY, "order_id", id, newInstance, "application_v7", false, useCache);
                }
            }
        }
    }
}